export default {
  global: {
    companyName: 'Backoffice Boilerplate',
    successTitle: 'All Right!',
    errorTitle: 'There was error',
    ok: 'OK',
    yes: 'Yes',
    no: 'No',
    screenLoadingText: 'Loading...',
    languages: {
      english: 'English',
      portuguese: 'Portuguese (BR)',
    },
    validation: {
      required: 'Required field',
    },
  },
}
